/**
 * 拡張モジュール
 */
require('@js/app/page-event-lib');
require('@js/app/keyevents');
require('@js/app/parsley-custom');
require('@js/app/parsley-ex');
